import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
  Switch,
} from "@chakra-ui/react";
import { FieldProps } from "@rjsf/utils";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

import { FileSize } from "./components/process-run-form-cell-size-file-size";
import { ProcessRunFormCellSizePicker } from "./components/process-run-form-cell-size-picker";

export function ProcessRunFormCellSize(props: FieldProps) {
  const { formData, onChange, schema, disabled, readonly } = props;
  const [visualValue, setVisualValue] = useState<number | string>(formData);
  const [isManual, setIsManual] = useState(false);
  const isReadOnly = readonly || disabled;
  return (
    <Box>
      <FormControl position="absolute" top={0} right={0} w="fit" display="flex" alignItems="center">
        <Switch
          pr={2}
          onChange={(e) => {
            setIsManual(e.target.checked);
          }}
          isChecked={isManual}
          id="is-manual"
        />
        <Box fontSize="xs" as={FormLabel} htmlFor="is-manual" mb="0">
          <FormattedMessage id="process.manual_entry" defaultMessage="Manual entry" />
        </Box>
      </FormControl>
      {isManual ? (
        <Box fontSize="sm">
          <Flex alignItems="center" gap={2}>
            <NumberInput
              h="small_button"
              min={schema.minimum || 0.01}
              value={visualValue}
              onChange={(newValue) => {
                setVisualValue(newValue);
                onChange(+newValue || 0);
              }}
              isReadOnly={isReadOnly}
            >
              <NumberInputField />
            </NumberInput>
          </Flex>
          <Box mt={2}>
            <FormLabel>
              <FormattedMessage id="process.file_size" defaultMessage="File size" />
            </FormLabel>
            <Flex mt={1} alignItems="center">
              <FileSize {...props} />
            </Flex>
          </Box>
        </Box>
      ) : (
        <ProcessRunFormCellSizePicker {...props} />
      )}
    </Box>
  );
}
